export const SET_UPDATES = 'SET_UPDATES'
export const SET_READ_UPDATES = 'SET_READ_UPDATES'
export const SET_USER = 'SET_USER'
export const SET_LOGIN = 'SET_LOGIN'
export const LOGIN_USER = 'LOGIN_USER'
export const PROCESS_LOGIN_RESPONSE = 'PROCESS_LOGIN_RESPONSE'
export const LOGOUT_USER = 'LOGOUT_USER'
export const REMOVE_LOGIN = 'REMOVE_LOGIN'
export const CHECK_LOGIN_ACCESS = 'CHECK_LOGIN_ACCESS'
export const APP_ERROR = 'APP_ERROR'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'
export const AUTO_HIDE_NOTIFICATION = 'AUTO_HIDE_NOTIFICATION'
export const SET_TEMPLATE_COLUMNS_MODE = 'SET_TEMPLATE_COLUMNS_MODE'
export const ADD_TEMPLATE_LINE = 'ADD_TEMPLATE_LINE'
export const SET_TEMPLATE_ROW_POSITION = 'SET_TEMPLATE_ROW_POSITION'
export const REMOVE_TEMPLATE_ROW = 'REMOVE_TEMPLATE_ROW'
export const SET_CANVAS_INSERT_MODE = 'SET_CANVAS_INSERT_MODE'
export const SET_CANVAS_EDIT_MODE = 'SET_CANVAS_EDIT_MODE'
export const ADD_COMPONENT_TO_ROW_AND_COLUMN =
  'ADD_COMPONENT_TO_ROW_AND_COLUMN'
export const SET_CURRENT_COMPONENT = 'SET_CURRENT_COMPONENT'
export const ADD_SLOT_COMPONENT = 'ADD_SLOT_COMPONENT'
export const REMOVE_SLOT_COMPONENT = 'REMOVE_SLOT_COMPONENT'
export const TEXT_EDITOR_INLINE_EDIT = 'TEXT_EDITOR_INLINE_EDIT'
export const TEXT_EDITOR_INLINE_EDIT_RAW = 'TEXT_EDITOR_INLINE_EDIT_RAW'
export const CLEAR_STATE_MODES = 'CLEAR_STATE_MODES'
export const EDIT_COMPONENT = 'EDIT_COMPONENT'
export const CLONE_COMPONENT = 'CLONE_COMPONENT'
export const DELETE_COMPONENT = 'DELETE_COMPONENT'
export const SET_BUILDER_LOADING = 'SET_BUILDER_LOADING'
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT'
export const REMOVE_CURRENT_PRODUCT = 'REMOVE_CURRENT_PRODUCT'
export const ADD_IMAGE = 'ADD_IMAGE'
export const REMOVE_IMAGES = 'REMOVE_IMAGES'
export const STORE_CURRENT_IMAGES = 'STORE_CURRENT_IMAGES'
export const SAVE_TEMPLATE_NAME = 'SAVE_TEMPLATE_NAME'
export const SAVE_CHECKOUT_FONT = 'SAVE_CHECKOUT_FONT'
export const SAVE_CHECKOUT_COLOR = 'SAVE_CHECKOUT_COLOR'
export const SAVE_CHECKOUT_BACKGROUND_COLOR = 'SAVE_CHECKOUT_BACKGROUND_COLOR'
export const SAVE_CHECKOUT_BACKGROUND_IMAGE = 'SAVE_CHECKOUT_BACKGROUND_IMAGE'
export const LOAD_DEFAULT_CHECKOUT = 'LOAD_DEFAULT_CHECKOUT'
export const LOAD_CURRENT_CHECKOUT = 'LOAD_CURRENT_CHECKOUT'
export const GET_DRAFT_CHECKOUTS = 'GET_DRAFT_CHECKOUTS'
export const SET_DRAFT_CHECKOUTS = 'SET_DRAFT_CHECKOUTS'
export const GET_PUBLISHED_CHECKOUTS = 'GET_PUBLISHED_CHECKOUTS'
export const SET_PUBLISHED_CHECKOUTS = 'SET_PUBLISHED_CHECKOUTS'
export const GET_TEMPLATES = 'GET_TEMPLATES'
export const SET_TEMPLATES = 'SET_TEMPLATES'
export const SET_CHECKOUT_DATA = 'SET_CHECKOUT_DATA'
export const CLEAR_CHECKOUT_DATA = 'CLEAR_CHECKOUT_DATA'
export const CHECKOUT_ACTIVE_TOGGLE = 'CHECKOUT_ACTIVE_TOGGLE'
export const CHECKOUT_ACTIVE_DISABLE = 'CHECKOUT_ACTIVE_DISABLE'
export const SET_ACTIVE_ROW = 'SET_ACTIVE_ROW'
export const SET_ACTIVE_COLUMN = 'SET_ACTIVE_COLUMN'
export const SET_CURRENT_PLATFORM = 'SET_CURRENT_PLATFORM'
export const UPDATE_DRAG_COMPONENT = 'UPDATE_DRAG_COMPONENT'
export const COPY_MOBILE_CHECKOUT_TO_DESKTOP =
  'COPY_MOBILE_CHECKOUT_TO_DESKTOP'
export const INSERT_TEMPLATE_ROW_BEFORE = 'INSERT_TEMPLATE_ROW_BEFORE'
export const INSERT_TEMPLATE_ROW_AFTER = 'INSERT_TEMPLATE_ROW_AFTER'
export const CLONE_TEMPLATE_ROW = 'CLONE_TEMPLATE_ROW'
export const SET_CHECKOUT_ACTIVE_EDIT = 'SET_CHECKOUT_ACTIVE_EDIT'
export const CLEAR_CHECKOUT_ACTIVE_EDIT = 'CLEAR_CHECKOUT_ACTIVE_EDIT'
export const SET_CURRENT_PRODUCT_DATA = 'SET_CURRENT_PRODUCT_DATA'
export const REFRESH_CHECKOUT_LIST = 'REFRESH_CHECKOUT_LIST'
export const CLEAR_CHECKOUT_LIST = 'CLEAR_CHECKOUT_LIST'
export const SET_CHECKOUT_ACTIVE_EDIT_OFFERS =
  'SET_CHECKOUT_ACTIVE_EDIT_OFFERS'
export const DELETE_CHECKOUT = 'DELETE_CHECKOUT'
export const SET_LAST_INSERT_COMPONENT = 'SET_LAST_INSERT_COMPONENT'
export const CLEAR_LAST_INSERT_COMPONENT = 'CLEAR_LAST_INSERT_COMPONENT'
export const SET_BUILDER_CHECKOUT_STATUS = 'SET_BUILDER_CHECKOUT_STATUS'
export const SET_LAST_UPDATED_PLATFORM = 'SET_LAST_UPDATED_PLATFORM'
export const SET_CHECKOUT_HISTORY = 'SET_CHECKOUT_HISTORY'
export const SET_DESKTOP_CHECKOUT = 'SET_DESKTOP_CHECKOUT'
export const CLEAR_BUILDER_DATA = 'CLEAR_BUILDER_DATA'
export const CLEAR_IMAGES = 'CLEAR_IMAGES'
export const EDIT_SLOT_COMPONENT = 'EDIT_SLOT_COMPONENT'
export const SET_CURRENT_EDIT_FORM = 'SET_CURRENT_EDIT_FORM'
export const GET_PRODUCTS = 'GET_PRODUCTS'
export const PRODUCT_ACCESS_DENIED = 'PRODUCT_ACCESS_DENIED'
export const CHECK_PRODUCT_OWNER = 'CHECK_PRODUCT_OWNER'
export const STORE_FEATURE_RULES = 'STORE_FEATURE_RULES'
export const SHOW_TRANSLATED_NOTIFICATION = 'SHOW_TRANSLATED_NOTIFICATION'
export const SET_TEMPLATE_UNSAVED_CHANGES = 'SET_TEMPLATE_UNSAVED_CHANGES'
export const SET_UNSAVED_WARNING = 'SET_UNSAVED_WARNING'
export const SET_ORDER_BUMP_DATA = 'SET_ORDER_BUMP_DATA'
export const SET_ORDER_BUMP_CUSTOM_IMAGE = 'SET_ORDER_BUMP_CUSTOM_IMAGE'
export const ADD_IN_CHECKOUT_COMPONENT = 'ADD_IN_CHECKOUT_COMPONENT'
export const REMOVE_IN_CHECKOUT_COMPONENT = 'REMOVE_IN_CHECKOUT_COMPONENT'
export const EDIT_IN_CHECKOUT_COMPONENT = 'EDIT_IN_CHECKOUT_COMPONENT'
export const SET_EDIT_IN_CHECKOUT_COMPONENT = 'SET_EDIT_IN_CHECKOUT_COMPONENT'
export const SET_COMPONENT_IN_DROP_MODE = 'SET_COMPONENT_IN_DROP_MODE'
export const INSERT_FIXED_COMPONENT = 'INSERT_FIXED_COMPONENT'
export const SET_ROW_EDIT_MODE = 'SET_ROW_EDIT_MODE'
export const CHANGE_MANAGING_PUBLICATION = 'CHANGE_MANAGING_PUBLICATION'
export const SET_THIS_CHECKOUT_ACTIVE = 'SET_THIS_CHECKOUT_ACTIVE'
export const SEND_EVENT_TO_DATAHUB = 'SEND_EVENT_TO_DATAHUB'
export const SET_NEED_FEEDBACK = 'SET_NEED_FEEDBACK'
export const SET_HAS_FEEDBACK = 'SET_HAS_FEEDBACK'
export const SEND_PUBLISHED_COMPONENTS_EVENT_TO_DATAHUB =
  'SEND_PUBLISHED_COMPONENTS_EVENT_TO_DATAHUB'
export const SEND_SAVE_BUILDER_WITHOUT_MOBILE =
  'SEND_SAVE_BUILDER_WITHOUT_MOBILE'
export const SEND_DROPOFF_BUILDER_CONFIG = 'SEND_DROPOFF_BUILDER_CONFIG'
export const SEND_CHANGE_PRODUCT = 'SEND_CHANGE_PRODUCT'
export const SET_USER_PHOTO_URL = 'SET_USER_PHOTO_URL'
export const GET_HOTLINKS_FOR_CURRENT_PRODUCT =
  'GET_HOTLINKS_FOR_CURRENT_PRODUCT'
export const SET_CURRENT_PRODUCT_HOTLINKS = 'SET_CURRENT_PRODUCT_HOTLINKS'
export const PUBLISH_CHECKOUT = 'PUBLISH_CHECKOUT'
export const DUPLICATE_CHECKOUT = 'DUPLICATE_CHECKOUT'
export const DUPLICATE_CHECKOUT_OTHER_PRODUCTS = 'DUPLICATE_CHECKOUT_OTHER_PRODUCTS'
export const SEND_SAVE_CHECKOUT = 'SEND_SAVE_CHECKOUT'
export const SEND_PAGEVIEW_DASHBOARD = 'SEND_PAGEVIEW_DASHBOARD'
export const SEND_PAGEVIEW_BUILDER = 'SEND_PAGEVIEW_BUILDER'
export const SET_JUST_PUBLISHED_CHECKOUT = 'SET_JUST_PUBLISHED_CHECKOUT'
export const SET_LAYOUT_IS_COPIED = 'SET_LAYOUT_IS_COPIED'
export const SEND_EDITED_PLATFORM_CHANGE = 'SEND_EDITED_PLATFORM_CHANGE'
export const SEND_COPY_CHECKOUT_LINK = 'SEND_COPY_CHECKOUT_LINK'
export const SEND_USE_DUPLICATE_CHECKOUT = 'SEND_USE_DUPLICATE_CHECKOUT'
export const SEND_USE_PREVIEW_AND_PUBLISH = 'SEND_USE_PREVIEW_AND_PUBLISH'
export const SEND_VIEW_SUCCESSFUL_PUBLISH_MODAL =
  'SEND_VIEW_SUCCESSFUL_PUBLISH_MODAL'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const OPEN_DELETE_CHECKOUT_MODAL = 'OPEN_DELETE_CHECKOUT_MODAL'
export const CLOSE_DELETE_CHECKOUT_MODAL = 'CLOSE_DELETE_CHECKOUT_MODAL'
export const OPEN_DUPLICATE_CHECKOUT_MODAL = 'OPEN_DUPLICATE_CHECKOUT_MODAL'
export const CLOSE_DUPLICATE_CHECKOUT_MODAL = 'CLOSE_DUPLICATE_CHECKOUT_MODAL'
export const OPEN_PUBLISH_MODAL = 'OPEN_PUBLISH_MODAL'
export const CLOSE_PUBLISH_MODAL = 'CLOSE_PUBLISH_MODAL'
export const OPEN_BUILDER_SAVE_MODAL = 'OPEN_BUILDER_SAVE_MODAL'
export const CLOSE_BUILDER_SAVE_MODAL = 'CLOSE_BUILDER_SAVE_MODAL'
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR'
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'
export const OPEN_UNPUBLISH_CHECKOUT_MODAL = 'OPEN_UNPUBLISH_CHECKOUT_MODAL'
export const CLOSE_UNPUBLISH_CHECKOUT_MODAL = 'CLOSE_UNPUBLISH_CHECKOUT_MODAL'
export const SAVE_NEW_CHECKOUT_TO_PUBLISH = 'SAVE_NEW_CHECKOUT_TO_PUBLISH'
export const SET_PREVIEW_WAS_OPEN = 'SET_PREVIEW_WAS_OPEN'
export const OPEN_PRODUCT_SELECT_MODAL = 'OPEN_PRODUCT_SELECT_MODAL'
export const CLOSE_PRODUCT_SELECT_MODAL = 'CLOSE_PRODUCT_SELECT_MODAL'
export const SET_INSTALLMENT_BUMPS_ADDED = 'SET_INSTALLMENT_BUMPS_ADDED'
export const SEND_SAVE_ORDER_BUMP = 'SEND_SAVE_ORDER_BUMP'
export const SEND_REDIRECT_CONFIGURATIONS = 'SEND_REDIRECT_CONFIGURATIONS'
export const SEND_EXIT_POPUP_RECOVERY_TOOL_ACTIVATION = 'SEND_EXIT_POPUP_RECOVERY_TOOL_ACTIVATION'
export const OPEN_EARLY_RENEWAL_OFFER_PICKER_MODAL = 'OPEN_EARLY_RENEWAL_OFFER_PICKER_MODAL'
export const CLOSE_EARLY_RENEWAL_OFFER_PICKER_MODAL = 'CLOSE_EARLY_RENEWAL_OFFER_PICKER_MODAL'
export const OPEN_PRODUCT_IMAGE_SELECT_MODAL = 'OPEN_PRODUCT_IMAGE_SELECT_MODAL'
export const CLOSE_PRODUCT_IMAGE_SELECT_MODAL = 'CLOSE_PRODUCT_IMAGE_SELECT_MODAL'
export const SET_EARLY_RENEWAL_DATA = 'SET_EARLY_RENEWAL_DATA'
export const SET_CURRENT_PRODUCT_EARLY_RENEWAL = 'SET_CURRENT_PRODUCT_EARLY_RENEWAL'
export const SET_PRODUCT_PLANS_EARLY_RENEWAL_DATA = 'SET_PRODUCT_PLANS_EARLY_RENEWAL_DATA'
export const SEND_PAGE_VIEW_EVENT = 'SEND_PAGE_VIEW_EVENT'
export const SEND_NAVBAR_EVENT = 'SEND_NAVBAR_EVENT'
export const SEND_PRODUCT_SEARCH_RESULT_EVENT = 'SEND_PRODUCT_SEARCH_RESULT_EVENT'
export const SEND_PRODUCT_LIST_SELECT_EVENT = 'SEND_PRODUCT_LIST_SELECT_EVENT'
export const SEND_PRODUCT_SELECT_EVENT = 'SEND_PRODUCT_SELECT_EVENT'
export const SEND_PAGE_SETTINGS_EVENT = 'SEND_PAGE_SETTINGS_EVENT'
export const SEND_BUILDER_NEW_PAGE_EVENT = 'SEND_BUILDER_NEW_PAGE_EVENT'
export const SEND_CLICK_TEMPLATE_EVENT = 'SEND_CLICK_TEMPLATE_EVENT'
export const SEND_USE_TEMPLATE_EVENT = 'SEND_USE_TEMPLATE_EVENT'
export const SEND_EDIT_COMPONENT_EVENT = 'SEND_EDIT_COMPONENT_EVENT'
export const SEND_PAGE_SAVE_EVENT = 'SEND_PAGE_SAVE_EVENT'
export const SEND_CHOOSE_ORDER_BUMP_EVENT = 'SEND_CHOOSE_ORDER_BUMP_EVENT'
export const SEND_PAGE_VIEW_EVENT__PRODUCT_SELECT = 'SEND_PAGE_VIEW_EVENT__PRODUCT_SELECT'
export const SEND_PAGE_VIEW_EVENT__CREATE_NEW_CHECKOUT = 'SEND_PAGE_VIEW_EVENT__CREATE_NEW_CHECKOUT'
export const SEND_PAGE_VIEW_EVENT__CREATE_NEW_CHECKOUT_FROM_TEMPLATE = 'SEND_PAGE_VIEW_EVENT__CREATE_NEW_CHECKOUT_FROM_TEMPLATE'
export const SEND_PAGE_VIEW_EVENT__BUILDER = 'SEND_PAGE_VIEW_EVENT__BUILDER'
export const SEND_PAGE_VIEW_EVENT__DASHBOARD = 'SEND_PAGE_VIEW_EVENT__DASHBOARD'
export const SET_PRODUCTS_WITH_ENRICHED_DATA = 'SET_PRODUCTS_WITH_ENRICHED_DATA'
export const ADD_PRODUCT_WITH_ENRICHED_DATA = 'ADD_PRODUCT_WITH_ENRICHED_DATA'
export const CLEAR_PRODUCTS_WITH_ENRICHED_DATA = 'CLEAR_PRODUCTS_WITH_ENRICHED_DATA'
export const SET_SKIP_ROUTE_INIT = 'SET_SKIP_ROUTE_INIT'
export const APPLY_CHECKOUT_LAYOUT_IDS = 'APPLY_CHECKOUT_LAYOUT_IDS'
export const SET_PREVIEW_IN_PROGRESS = 'SET_PREVIEW_IN_PROGRESS'
